/* Goodword: Add to cart on book / Etsy pages adds by AJAX and opens the cart drawer
   (the product forms are plain /cart/add forms, which would jump to the cart page). */
document.addEventListener('submit', function (e) {
  var f = e.target;
  if (!f || !f.matches || !f.matches('form[action$="/cart/add"]')) return;
  var drawer = document.querySelector('cart-drawer');
  if (!drawer || !window.routes) return; // no drawer on this page → normal submit
  e.preventDefault();

  var btn = f.querySelector('[type=submit]');
  if (btn && btn.disabled) return;
  if (btn) btn.disabled = true;
  var err = f.querySelector('.gw-add-error');
  if (err) err.remove();

  var fd = new FormData(f);
  fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
  fd.append('sections_url', window.location.pathname);

  fetch(window.routes.cart_add_url, {
    method: 'POST',
    body: fd,
    headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
  })
    .then(function (r) { return r.json(); })
    .then(function (j) {
      if (j.status) { // Shopify refused (e.g. not enough stock)
        var p = document.createElement('p');
        p.className = 'gw-add-error';
        p.setAttribute('role', 'alert');
        p.textContent = j.description || j.message || 'Could not add to cart';
        (btn || f).insertAdjacentElement('afterend', p);
        return;
      }
      drawer.classList.remove('is-empty'); // first item into an empty cart
      drawer.renderContents(j);
    })
    .catch(function () { f.submit(); }) // network hiccup → old behaviour (cart page)
    .then(function () { if (btn) btn.disabled = false; });
});

/* "−" at quantity 1 removes the line (as on the old store); Dawn alone only shows "minimum of 1". */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('.quantity__button[name="minus"]');
  var item = b && b.closest('.cart-item');
  var inp = b && b.closest('quantity-input') && b.closest('quantity-input').querySelector('input');
  var rm = item && item.querySelector('cart-remove-button');
  if (!rm || !inp || parseInt(inp.value, 10) > 1) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  rm.click();
}, true);
